import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import withSplashScreen from "../src/components/SplashScreen";

const AppWithSplash = withSplashScreen(App);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(<AppWithSplash />);
